@if (isVisible) {
    <div class="horses-tournament-selector" msHeightToBottom [msColumnWidth]="isSports ? 'breadcrumb' : null">
        @for (tg of tournamentGroups; track $index) {
            <div class="tournament-group" [class.expanded]="tg.expanded">
                @if (tg.tournaments.length) {
                    <div class="day-header" [class.header-collapsed]="!tg.expanded" (click)="toggleGroup(tg)">
                        <span class="day-header-title">{{ translateTournamentGroup(tg.id) }}</span>
                        <span class="day-header-arrow">
                            @if (!tg.expanded) {
                                <span>{{ tg.tournaments.length }}</span>
                            }
                            <a class="icon horses-tournament-selector__expand-arrow">
                                <vn-icon size="16" class="selector-arrow" [name]="tg.expanded ? 'theme-up' : 'theme-down'"></vn-icon>
                            </a>
                        </span>
                    </div>
                }
                @if (isSports) {
                    @if (tg.tournaments.length && tg.expanded) {
                        <div class="tournament-list">
                            @if (tg.id === 'Today' || tg.id === 'Tomorrow') {
                                @for (tournament of tg.tournaments; track $index) {
                                    <div
                                        class="tournament"
                                        [class.tournament--selected]="tournament.attributes.selected"
                                        (click)="goToTournament(tournament.meeting, tg.id)">
                                        {{ tournament.meeting.tag.name | msTranslate }}
                                        @if (promotedMeetingIdsMap[tournament.meeting.tag.id]) {
                                            <ms-promotion-badge></ms-promotion-badge>
                                        }
                                    </div>
                                }
                            }
                            @for (tournament of tg.tournaments; track $index) {
                                <a class="tournament" [href]="tournament.url" (click)="goToTournament(tournament.meeting, tg.id)">
                                    {{ tournament.meeting.name | msTranslate }}
                                </a>
                            }
                        </div>
                    }
                } @else {
                    @if (tg.tournaments.length && tg.expanded) {
                        <div class="tournament-list" (click)="toggleGroup(tg)">
                            @for (tournament of tg.tournaments; track $index) {
                                <div class="tournament" (click)="goToTournament(tournament, tg.id)">
                                    {{ tournament.tag.name | msTranslate }}
                                </div>
                            }
                        </div>
                    }
                }
            </div>
        }
    </div>
}
